<template>
  <div
    ref="component"
    class="tva-line-chart-component"
    v-resize="onResize"
    :style="{
      width: config.globalFixedWidth ? config.globalFixedWidth + 'px' : '100%',
      height: config.globalFixedHeight
        ? config.globalFixedHeight + 'px'
        : '100%'
    }"
  >
    <svg>
      <defs>
        <linearGradient id="Gradient1" x1="0" x2="0" y1="0" y2="1">
        <stop class="stop1" offset="0%" stop-color="var(--white_04)"/>
        <stop class="stop3" offset="50%" stop-color="var(--white_00)"/>
      </linearGradient>
      </defs>
      <Grid :p="params" :c="config" :d="data" />
      <g class="line" v-for="serie in config.series" :key="serie.key">
        <LinePath :p="params" :c="config" :d="computedData" :serie="serie" />
        <AreaPath :p="params" :c="config" :d="computedData" :serie="serie" />
        <Dots :p="params" :c="config" :d="computedData" :serie="serie" />
      </g>
      <XAxis :p="params" :c="config" :d="computedData" />
      <!-- <YAxis :p="params" :c="config" /> -->
      <!-- <Tooltip
        :p="params"
        :c="config"
        :d="data"
        @tooltipMove="tooltipMove = $event"
      /> -->
      <!-- <Legend :p="params" :c="config" /> -->
    </svg>
  </div>
</template>

<script>
import global from "@/mixins/global";
import grid from "@/mixins/grid";

import Grid from "./Grid";
import LinePath from "./LinePath";
import AreaPath from "./AreaPath";
import Dots from "./Dots";
import XAxis from "./XAxis";
// import YAxis from "./YAxis";
// import Tooltip from "./Tooltip";
// import Legend from "./Legend";

export default {
  props: ["data", "config"],
  mixins: [global, grid],
  computed: {
    params() {
      return {
        width: this.width,
        height: this.height,
        left: this.left,
        right: this.right,
        minX: this.maxMinX.min,
        maxX: this.maxMinX.max,
        minY: this.maxMinY[0].min,
        maxY: this.maxMinY[0].max,
        ticksX: this.ticksX,
        ticksY: this.ticksY,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        format: this.format,
        tooltipMove: this.tooltipMove
      };
    }
  },
  components: {
    Grid,
    LinePath,
    AreaPath,
    Dots,
    XAxis,
    // YAxis,
    // Tooltip,
    // Legend
  }
};
</script>

<style lang="scss" scoped>
.tva-line-chart-component {
  width: 100%;
  height: 100%;
  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
  }
}
</style>
